import { Card, Spacer, Typography } from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { ContactsO } from '@bcp-nextgen-dx-component-factory/accolade-design-system/dist/assets/MBCP/icons';
import { rem } from '@helpers';
import { useSummaryNextStepsHelper } from './summaryNextSteps.helper';
import { SummaryNextStepsItem } from './summaryNextStepsItem';

export const SummaryNextSteps: React.FC = () => {
	const { cardProps, resources } = useSummaryNextStepsHelper();
	return (
		<>
			<Typography appearance="subtitle-100-04">{resources.nextStepsTitle}</Typography>
			<Spacer vertical={rem(24)} />
			<>
				<Card {...cardProps}>
					<SummaryNextStepsItem
						title={resources.contactTitle}
						description={resources.contactDescription}
						mainIcon={<ContactsO />}
					/>
				</Card>
			</>
		</>
	);
};
